export const TYPHOON_ACTIVITY_ID = 58
export const TYPHOON_TEMPLATE = '因颱風影響，為維護患者與同仁安全，本診所將於 ○ 月 ○ 日（星期○）暫停看診。診所人員會於恢復上班後依序聯絡改約，造成不便敬請見諒，請您注意安全～'

export function getNextTyphoonContent(newActivity, oldActivity, currentContent) {
  if (newActivity === TYPHOON_ACTIVITY_ID && (currentContent == null || currentContent.trim() === '')) {
    return TYPHOON_TEMPLATE
  }
  if (oldActivity === TYPHOON_ACTIVITY_ID && newActivity !== TYPHOON_ACTIVITY_ID && currentContent === TYPHOON_TEMPLATE) {
    return null
  }
  return currentContent
}
